import { UserName } from "../../Users/shared/UserName.js";
import { LocationName } from "../../Locations/shared/LocationName.js";
import { UserAnPCheck } from "../UserAnPCheck.js";
import { LabeledInputDisplay } from "../LabeledInput/LabeledInputDisplay.js";
import { SearchFilterUserActiveInactiveMultiSelect } from "../../Users/shared/SearchFilterUserActiveInactiveMultiSelect.js";
import { SearchFilterLocationMultiSelect } from "../../Locations/shared/SearchFilterLocationMultiSelect.js";
import { SearchFilterActivityFeedScopeMultiSelect } from "./SearchFilterActivityFeedScopeMultiSelect.js";
import { ActivityFeedScopeTitles } from "./ActivityFeedScopeTitles.js";
import { SEARCH_FILTER_FILTER_LABELS } from "../constants.js";
import { useState } from "react";
import { Modal } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/shared/ActivityFeed/ActivityFeedSearchFiltersModal.tsx
function ActivityFeedSearchFiltersModal({ filtersState, onClose, setFiltersState, showLocations = true, showUsers = true }) {
	const [focusedFilter, setFocusedFilter] = useState();
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler: onClose,
		escPressClose: true,
		header: "Advanced Search Filters",
		outsideClickClose: true,
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-y-xs flex flex-col",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: classnames({
						"grid-cols-2": showLocations && !showUsers || showUsers && !showLocations,
						"grid-cols-3": showUsers && showLocations
					}, "gap-x-xxs grid hover:cursor-pointer"),
					children: [
						/* @__PURE__ */ jsx("div", {
							onClick: () => {
								if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.SCOPE) setFocusedFilter("");
								else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.SCOPE);
							},
							children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
								displayOnly: true,
								label: "Activity Feed Type",
								nameElement: /* @__PURE__ */ jsx(ActivityFeedScopeTitles, {
									scopes: filtersState.scope || [],
									listAll: false
								}),
								value: filtersState.scope
							})
						}),
						/* @__PURE__ */ jsx(UserAnPCheck, {
							check: (user) => user.anp.role.ops.access.viewUserActivity,
							children: showLocations && /* @__PURE__ */ jsx("div", {
								onClick: () => {
									if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.LOCATION) setFocusedFilter("");
									else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.LOCATION);
								},
								children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
									displayOnly: true,
									label: "Location",
									nameElement: /* @__PURE__ */ jsx(LocationName, { locationId: filtersState.locationId || "" }),
									value: filtersState.locationId
								})
							})
						}),
						/* @__PURE__ */ jsx(UserAnPCheck, {
							check: (user) => user.anp.role.ops.access.viewUserActivity,
							children: showUsers && /* @__PURE__ */ jsx("div", {
								onClick: () => {
									if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.USER) setFocusedFilter("");
									else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.USER);
								},
								children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
									displayOnly: true,
									label: "User",
									nameElement: /* @__PURE__ */ jsx(UserName, { userId: filtersState.userId }),
									value: filtersState.userId
								})
							})
						})
					]
				}),
				/* @__PURE__ */ jsx(SearchFilterActivityFeedScopeMultiSelect, {
					focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.SCOPE,
					onChange: (val) => {
						setFiltersState({ scope: val });
					},
					onClearSelection: () => {
						setFiltersState({ scope: void 0 });
					},
					onClick: () => {
						if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.SCOPE) setFocusedFilter("");
						else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.SCOPE);
					},
					value: filtersState.scope
				}),
				/* @__PURE__ */ jsx(UserAnPCheck, {
					check: (user) => user.anp.role.ops.access.viewUserActivity,
					children: showLocations && /* @__PURE__ */ jsx(SearchFilterLocationMultiSelect, {
						focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.LOCATION,
						label: "Location",
						onChange: (val) => {
							if (filtersState.locationId && !!val?.length) setFiltersState({ locationId: val.filter((_val) => filtersState.locationId !== _val)[0] });
							else setFiltersState({ locationId: val[0] });
						},
						onClearSelection: () => {
							setFiltersState({ locationId: void 0 });
						},
						onClick: () => {
							if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.LOCATION) setFocusedFilter("");
							else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.LOCATION);
						},
						value: filtersState.locationId ? [filtersState.locationId] : void 0
					})
				}),
				/* @__PURE__ */ jsx(UserAnPCheck, {
					check: (user) => user.anp.role.ops.access.viewUserActivity,
					children: showUsers && /* @__PURE__ */ jsx(SearchFilterUserActiveInactiveMultiSelect, {
						focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.USER,
						label: "User",
						selectMode: "single",
						onChange: (val) => {
							if (filtersState.userId && !!val?.length) setFiltersState({ userId: val.filter((_val) => filtersState.userId !== _val)[0] });
							else setFiltersState({ userId: val[0] });
						},
						onClearSelection: () => {
							setFiltersState({ userId: void 0 });
						},
						onClick: () => {
							if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.USER) setFocusedFilter("");
							else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.USER);
						},
						value: filtersState.userId ? [filtersState.userId] : void 0
					})
				})
			]
		})
	});
}
//#endregion
export { ActivityFeedSearchFiltersModal };

//# sourceMappingURL=ActivityFeedSearchFiltersModal.js.map